export enum TemplateProcessStatus {
  NOT_UPLOADED = 'NOT_UPLOADED',
  FILE_UPLOADED = 'FILE_UPLOADED',
  REFINED_BY_AI = 'REFINED_BY_AI'
}

export interface Template {
  id: string;
  name: string;
  version: string;
  description: string;
  is_latest: boolean;
  created_at: string;
  updated_at: string;
  created_by: string;
  default_personas: string[];
  process_status: TemplateProcessStatus;
  s3_key?: string | null;
}

export interface GetTemplatesQueryParams {
  show_latest?: boolean;
}

export interface TemplateRequest {
  name: string;
  description: string;
  default_personas?: string[];
}

export interface CreateTemplateVersionResponse {
  id: string;
  version: string;
}

export interface UploadUrlResponse {
  file_name: string;
  s3_key: string;
  url: string;
}

export interface GenerateUploadUrlRequest {
  extension: string;
}

export interface DownloadUrlResponse {
  url: string;
}

export interface AgentStatusResponse {
  status: string;
}
